export default __webpack_public_path__ + "static/media/Lu.46bfcd52.png";